import { z } from 'zod';
import { MetricDefinitionWhiteLabeling } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';

export const PreloadableMetricDefinitionWhiteLabelType = z.enum([
  // HRIS
  'Hiring',
  'Promotion',
  'Performance',
  'Attrition',
  'Compensation',
  'Engagement',
  // Police Departments (Stops)
  'Search and Frisk',
  'Arrests',
  'Use of Force',
  'Contraband Found',
  'Total Contraband',
]);

export type PreloadableMetricDefinitionWhiteLabelType = z.infer<
  typeof PreloadableMetricDefinitionWhiteLabelType
>;

export const PreloadableMetricDefinitionWhiteLabelTypeValues: PreloadableMetricDefinitionWhiteLabelType[] =
  Object.values(PreloadableMetricDefinitionWhiteLabelType.Values);

export const preloadableMetricDefinitionWhiteLabels: Record<
  PreloadableMetricDefinitionWhiteLabelType,
  MetricDefinitionWhiteLabeling
> = {
  Hiring: {
    subjectSingular: 'applicant',
    subjectPlural: 'applicants',
    subjectPassiveVerb: 'are hired',
    subjectConditionalVerb: 'would be hired',
    proceseesDescription: 'hiring processes',
  },
  Promotion: {
    subjectSingular: 'employee',
    subjectPlural: 'employees',
    subjectPassiveVerb: 'are promoted',
    subjectConditionalVerb: 'would be promoted',
    proceseesDescription: 'promotion processes',
  },
  Performance: {
    subjectSingular: 'employee',
    subjectPlural: 'employees',
    subjectPassiveVerb: 'performed',
    subjectConditionalVerb: 'would perform',
    proceseesDescription: 'processes',
  },
  Attrition: {
    subjectSingular: 'employee',
    subjectPlural: 'employees',
    subjectPassiveVerb: 'stayed',
    subjectConditionalVerb: 'would stay',
    proceseesDescription: 'processes',
  },
  Compensation: {
    subjectSingular: 'employee',
    subjectPlural: 'employees',
    subjectPassiveVerb: 'are compensated',
    subjectConditionalVerb: 'would be compensated',
    proceseesDescription: 'salary adjustment processes',
  },
  Engagement: {
    subjectSingular: 'employee',
    subjectPlural: 'employees',
    subjectPassiveVerb: 'engaged',
    subjectConditionalVerb: 'would be engaged',
    proceseesDescription: 'processes',
  },
  'Search and Frisk': {
    subjectSingular: 'citizen',
    subjectPlural: 'citizens',
    subjectPassiveVerb: 'are searched and frisked',
    subjectConditionalVerb: 'would be searched and frisked',
    proceseesDescription: 'search and frisk processes',
  },
  Arrests: {
    subjectSingular: 'citizen',
    subjectPlural: 'citizens',
    subjectPassiveVerb: 'are arrested',
    subjectConditionalVerb: 'would be arrested',
    proceseesDescription: 'arrest processes',
  },
  'Use of Force': {
    subjectSingular: 'citizen',
    subjectPlural: 'citizens',
    subjectPassiveVerb: 'had force used on them',
    subjectConditionalVerb: 'would have had force used on them',
    proceseesDescription: 'use of force processes',
  },
  'Contraband Found': {
    subjectSingular: 'citizen',
    subjectPlural: 'citizens',
    subjectPassiveVerb: 'had contraband found on them',
    subjectConditionalVerb: 'would have had contraband found on them',
    proceseesDescription: 'processes',
  },
  'Total Contraband': {
    subjectSingular: 'citizen',
    subjectPlural: 'citizens',
    subjectPassiveVerb: 'had contraband found on them',
    subjectConditionalVerb: 'would have had contraband found on them',
    proceseesDescription: 'processes',
  },
};
